<section class="g-brd-bottom g-brd-gray-light-v4 g-py-30 breadcrumbs">
    <div class="container">
        <ul class="d-flex justify-content-between u-list-inline">
            <li class="list-inline-item g-mr-15">
                <a class="u-link-v5 g-color-text g-pr-10" routerLink="/">Home</a>
                <i class="g-color-gray-light-v2 g-ml-5 fa fa-angle-right"></i>
            </li>
            <li class="list-inline-item g-color-primary">
                <span>Blog</span>
            </li>
            <li class="list-inline-item ml-auto"></li>
        </ul>
    </div>
</section>
<div class="container g-pt-100 g-pb-70" style="margin-top: -50px">
    <!-- Heading -->
    <div class="g-max-width-550 text-center mx-auto g-mb-70">
        <h1 class="h3 mb-5">
            <p>Blog</p>
        </h1>
    </div>
    <!-- End Heading -->

    <!-- the loading spinner -->
    <div *ngIf="isLoading" class="text-center my-5">
        <div class="u-spinner-v1 g-height-70 g-width-70 g-color-primary mx-auto">
            <div class="u-spinner-inner"></div>
        </div>
        <p class="g-mt-20 g-color-gray-dark-v4">Loading blog posts...</p>
    </div>

    <div class="row" *ngIf="!isLoading">
        <div class="col-lg-12 g-mb-30">
            <div class="row g-mx-minus-25 g-mb-50">
                <div *ngFor="let blog of blogsDetails?.data" class="col-lg-6 g-px-25 g-mb-50">
                    <!-- Blog Grid Modern Blocks -->
                    <article class="u-shadow-v21 g-bg-white g-rounded-5 g-transition-0_3 hover-shadow">
                        <div class="row no-gutters">
                            <div class="col-md-6">
                                <div class="g-overflow-hidden g-rounded-left-5 h-100">
                                    <img
                                        class="img-fluid w-100 h-100 g-transform-scale-1_03--hover g-transition-0_3"
                                        style="object-fit: cover; min-height: 280px"
                                        src="{{ blog.image }}"
                                        alt="{{ blog.title }}"
                                    />
                                </div>
                            </div>

                            <div class="col-md-6 g-bg-white g-rounded-right-5">
                                <div class="g-pa-30">
                                    <h3 class="h4 g-color-black g-font-weight-600 mb-3">
                                        <a
                                            class="u-link-v5 g-color-black g-color-primary--hover"
                                            routerLink="/blog/{{ blog?.id }}/blog-details"
                                        >
                                            {{ blog?.title }}
                                        </a>
                                    </h3>

                                    <div
                                        class="g-color-gray-dark-v2 g-font-size-15 g-mb-20"
                                        [innerHTML]="
                                            blog?.content.length > 100
                                                ? blog?.content.slice(0, 150) + '...'
                                                : blog?.content
                                        "
                                    ></div>

                                    <a
                                        class="g-brd-main g-brd-primary--hover g-bg-main g-bg-primary--hover text-white u-tags-v1 g-rounded-50 g-py-4 g-px-15"
                                        [routerLink]="['/blog', formatUrl(blog?.title)]"
                                    >
                                        Read more
                                    </a>
                                </div>
                            </div>
                        </div>
                    </article>

                    <!-- End Blog  data-bg-img-src="blog?.image" Grid Modern Blocks -->
                </div>
            </div>
        </div>
    </div>
    <mat-paginator
        *ngIf="!isLoading"
        class="mat-elevation-z8"
        [length]="blogsDetails?.totalRecords"
        [showFirstLastButtons]="true"
        [pageSize]="pageSize"
        (page)="pageLoad($event)"
    >
    </mat-paginator>
</div>
